import { useSelector } from 'react-redux'
import { positionDropdown } from '../../../common/dropdown'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { Tooltip } from '../../../common/tooltip'
import { formatVal } from '../../../helpers/value'

export const TriggerCell = ({ rowId, data = [] }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const portfolioTrigger = data.filter((item) => item.isPortfolioTrigger)

  if (!portfolioTrigger.length) return null

  return (
    <Element>
      <Tooltip
        tooltipContent={
          <div style={{ maxWidth: 400 }}>
            {portfolioTrigger.map((item, index) => (
              <TextEllipsisStaticLine
                key={index}
                text={item.portfolioName}
                lineClamp={1}
                isI18n={false}
              />
            ))}
          </div>
        }
        position={positionDropdown.BOTTOM_CENTER}
        contentClass="wFitContent dFlex alignItemsEnd"
      >
        <Icon
          className="icon-folder"
          style={{
            fontSize: 13,
            color: '#FFCD60',
            marginRight: 3,
          }}
        />

        <span>{formatVal(portfolioTrigger.length, locale, false, 0)}</span>
      </Tooltip>
    </Element>
  )
}
